module.exports = __webpack_public_path__ + "static/img/zm.a9ff495d.svg";